import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=de45a13a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de45a13a')) {
      api.createRecord('de45a13a', component.options)
    } else {
      api.reload('de45a13a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=de45a13a&", function () {
      api.rerender('de45a13a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21vwooRuNf4EY/JS/comp/IncreaseNumber.vue"
export default component.exports